export const Planetas =() =>{
    return(
        <>
        <option value={"Mercúrio"}>Mercúrio</option>
        <option value={"Vênus"}>Vênus</option>
        <option value={"Terra"}>Terra</option>
        <option value={"Marte"}>Marte</option>
        <option value={"Jupiter"}>Jupiter</option>
        <option value={"Saturno"}>Saturno</option>
        <option value={"Urano"}>Urano</option>
        <option value={"Netuno"}>Netuno</option>
        <option value={"Plutão"}>Plutão</option>
        </>
    )
}